import { SubHeadingTitle } from "../../../../components/shared/index";

import styles from "./useraddress.module.css";
import { FaHeart, FaRegHeart } from "react-icons/fa";
const UserAddressList = ({ addressList, onSelect, selectedAddress  ,   favoriteAddressId,
  onSetFavorite,}) => {
  return (
    <div className={styles.addressWrapper}>
      {addressList?.map((item) => {
        const isActive = selectedAddress?.id === item.id;
const isFavorite = favoriteAddressId == item.id;
        return (
          <div
            key={item.id}
            className={`${styles.addressCard} ${
              isActive ? styles.activeCard : ""
            }`}
            onClick={() => onSelect(item)}
          >
            <div className={styles.addressInfo}>
              <SubHeadingTitle
                subTitle={item?.name}
                style={styles.addressName}
              />
              <SubHeadingTitle
                subTitle={`Mob No : ${item?.phone}`}
                style={styles.addressPhone}
              />
              <SubHeadingTitle
                subTitle={`${item?.address || ""}, ${item?.city || ""}`}
                style={styles.addressLine}
              />
              <SubHeadingTitle subTitle={`Pin Code : ${item?.zip}`} style={styles.addressZip} />
            </div> 
  <button
  className={styles.favoriteBtn}
  onClick={(e) => {
    e.stopPropagation();
    onSetFavorite(item.id);
  }}
>
  {isFavorite ? (
    <FaHeart className={styles.heartActive} />
  ) : (
    <FaRegHeart className={styles.heart} />
  )}
</button>
          </div>
        );
      })}
    </div>
  );
};

export default UserAddressList;
